/* (ignored) */


//////////////////
// WEBPACK FOOTER
// vertx (ignored)
// module id = 8
// module chunks = main